import { FormField } from "@/types";
import { $t } from "@/lib/helpers/i18nHelper";

export const fields: Array<FormField & { fieldMeta?: Record<any, any> }> = [
  {
    name: "about",
    title: $t("About"),
    type: "textarea",
    fieldMeta: {
      allowedForMember: true,
    },
  },
  {
    name: "location",
    title: $t("Location"),
  },
  {
    name: "website",
    title: $t("Personal website"),
    fieldMeta: {
      allowedForMember: true,
    },
  },
  {
    name: "twitter",
    title: $t("Twitter account"),
  },
  {
    name: "facebook",
    title: $t("Facebook account"),
  },
  {
    name: "instagram",
    title: $t("Instagram account"),
  },
  {
    name: "tiktok",
    title: $t("TikTok account"),
  },
  {
    name: "youtube",
    title: $t("YouTube account"),
  },
  {
    name: "snapchat",
    title: $t("Snapchat account"),
  },
  {
    name: "patreon",
    title: $t("Patreon account"),
  },
  {
    name: "onlyfans",
    title: $t("OnlyFans account"),
  },
  {
    name: "sensitiveContent",
    title: $t("Has sensitive content"),
    type: "checkbox",
    fieldMeta: {
      allowedForMember: true,
    },
  },
];
